<form [formGroup]="formGroup">
    <h4><mat-icon>storefront</mat-icon>&nbsp;Multi-restaurants</h4>
    <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title><mat-icon>help_outlined</mat-icon>&nbsp;Votre fichier comporte plusieurs restaurants mais le traitement comptable diffère ?</mat-panel-title>
        </mat-expansion-panel-header>
        <p>Il faudra créer un connecteur par restaurant et renseigner pour chacun l'identifiant du restaurant à traiter.</p>
        <p>L'identifiant à renseigner est dans votre fichier, colonne E (restaurant_statement.shop_id.definition / Id. du restaurant).</p>
        <img src="/assets/documentation/connectors/extract-nodes/uber-eats/restaurant_filter.png" alt="Filtre restaurant uber eats"/>
      </mat-expansion-panel>
      <br/>
      <mat-form-field class="two-thirds-width">
        <mat-label>ID Restaurant à traiter (facultatif)</mat-label>
        <input
            matInput
            type="text"
            formControlName="restaurantFilter"
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
      </mat-form-field>
</form>